module.exports = __webpack_public_path__ + "img/crocodile.fcaaa95.png";